import React, { useState } from "react";
import { Form, Input, Button, Upload, Card, Typography, Spin } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const { Title } = Typography;
const { TextArea } = Input;

const AdminAddPaymentMethods = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const user = JSON.parse(localStorage.getItem("admin"));
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  const onFinish = async (values) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("gateway_name", values.gateway_name);
    formData.append("action_url", values.action_url);

    const imageFile = values.gateway_image?.[0]?.originFileObj;
    if (imageFile) {
      formData.append("gateway_image", imageFile);
    }

    formData.append("description", values.description || "");

    try {
      const res = await fetch(
        `${process.env.REACT_APP_APIURL}/admin/createpaymentgateway`,
        {
          method: "POST",
          body: formData,
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      const response = await res.json();

      if (response?.status_code === 200) {
        toast.success(t("Add_Gateway_success"));
        navigate("/admin/payment-gateway");
      } else {
        toast.error(response?.message || response?.err);
      }
    } catch (error) {
      toast.error(t("Something_went_wrong"));
    }
    setLoading(false);
  };

  return (
    <>
      <Title level={4}>{t("Add_Gateway2")}</Title>

      <Spin spinning={loading}>
        <Card className="max-w-2xl mx-auto">
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            initialValues={{ gateway_name: "", action_url: "", description: "" }}
          >
            <Form.Item
              name="gateway_name"
              label={t("Gateway_Name")}
              rules={[{ required: true, message: t("Please_enter_gateway_name") }]}
            >
              <Input placeholder={t("Gateway_Name")} />
            </Form.Item>

            <Form.Item
              name="action_url"
              label={t("Action_Url")}
              rules={[{ required: true, message: t("Please_enter_action_url") }]}
            >
              <Input placeholder={t("Action_Url")} />
            </Form.Item>

            <Form.Item
              name="gateway_image"
              label={t("Gateway_Image")}
              valuePropName="fileList"
              getValueFromEvent={normFile}
              rules={[{ required: true, message: t("Please_upload_image") }]}
            >
              <Upload
                name="gateway_image"
                maxCount={1}
                beforeUpload={() => false}
                listType="picture"
              >
                <Button icon={<UploadOutlined />}>{t("Click_to_Upload")}</Button>
              </Upload>
            </Form.Item>

            <Form.Item
              name="description"
              label={t("Description")}
              rules={[{ required: false }]}
            >
              <TextArea rows={4} placeholder={t("Description")} />
            </Form.Item>

            <Form.Item>
              <div className="flex justify-center gap-4">
                <Link to="/admin/payment-gateway">
                  <Button danger>{t("Cancel")}</Button>
                </Link>
                <button
                  type="submit"
                  loading={loading}
                  className="btn btn-primary text-white btn-sm"
                >
                  {t("Save")}
                </button>
              </div>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    </>
  );
};

export default AdminAddPaymentMethods;
